import * as React from 'react'

function IconDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={52}
      height={47}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 30.93V16.523C3 9.053 9.04 3 16.493 3h19.01C42.96 3 49 9.058 49 16.523V30.93M25.594 44.16V23.175"
        stroke="#fff"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M34.473 27.211l-5.61-6.716a3.708 3.708 0 00-5.73 0l-5.608 6.716"
        stroke="#fff"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconDownload
